import React,{useState,useEffect} from 'react'
import Title from '../../../../components/panelcontrols/paneltitle'
import Table from './orderTable'
import Functions from './functions'
import Button from '../../../../components/panelcontrols/panelbuttonmain'
import StatusEdit from './statusSelector'
import DepartmentEdit from './departmentSelector'
import EditPopup from '../../../../components/panelcontrols/panelpopup'
import { ToastContainer, toast } from 'react-toastify';

const Index = () => {
  const [showStatusEdit,setShowStatusEdit] = useState(false);
  const [showDepartmentEdit,setShowDepartmentEdit] = useState(false);
  const [selectedOrder,setSelectedOrder] = useState(0);
  const [selectedStatus,setSelectedStatus] = useState(0);
  const [selectedDepartment,setSelectedDepartment] = useState(0);
  const [list,setList] = useState([]);
  const [page,setPage] = useState(1);
  const [paginationInfo,setPaginationInfo] = useState({ pages: 1, total: 0 });
  const [searchTerm,setSearchTerm] = useState('');
  const [debouncedSearch,setDebouncedSearch] = useState('');
  const limit = 20;

  useEffect(()=>{
    const t = setTimeout(()=>{
      setDebouncedSearch(searchTerm);
      setPage(1);
    },350);
    return ()=>clearTimeout(t);
  },[searchTerm]);

  // Set before every fetch, not just the first: on a page change or a search the old rows stay
  // on screen and dim, rather than the table blanking out and reflowing on each keystroke.
  const [loading,setLoading] = useState(true);
  const applyList = (data)=>{
    setList(data);
    setLoading(false);
  };
  useEffect(()=>{
    setLoading(true);
    Functions.Get(applyList, setPaginationInfo, page, limit, debouncedSearch);
  },[page, debouncedSearch])

  return (
    <div className='labadmin_order_list_container'>
      <Title Value={'Orders'}/>
      <div style={{display:"flex",justifyContent:"flex-end"}}>
        <div style={{width:"25%"}}>
          <Button Value={'Add New'} Action={()=>{
            document.location.replace('/labadmin/orders/new');
          }}/>
        </div>
      </div>
      <Table List={list} setList={setList} loading={loading} search={searchTerm} onSearch={setSearchTerm} setShowStatusEdit={setShowStatusEdit} setSelectedOrder={setSelectedOrder} setSelectedStatus={setSelectedStatus} setShowDepartmentEdit={setShowDepartmentEdit} setSelectedDepartment={setSelectedDepartment}/>
      <div style={{display:'flex',justifyContent:'center',alignItems:'center',gap:'12px',padding:'16px'}}>
        <button
          onClick={()=>setPage(p=>p-1)}
          disabled={page<=1}
          style={{padding:'6px 16px',cursor:page<=1?'not-allowed':'pointer',opacity:page<=1?0.5:1,borderRadius:'4px',border:'1px solid #ccc'}}>
          Previous
        </button>
        <span style={{fontSize:'14px'}}>Page {page} of {paginationInfo.pages || 1} &nbsp;|&nbsp; Total: {paginationInfo.total || 0}</span>
        <button
          onClick={()=>setPage(p=>p+1)}
          disabled={page>=(paginationInfo.pages||1)}
          style={{padding:'6px 16px',cursor:page>=(paginationInfo.pages||1)?'not-allowed':'pointer',opacity:page>=(paginationInfo.pages||1)?0.5:1,borderRadius:'4px',border:'1px solid #ccc'}}>
          Next
        </button>
      </div>
      {showStatusEdit &&
        <EditPopup setShowEdit={setShowStatusEdit} width={'50%'} Container={<StatusEdit selectedOrder={selectedOrder} selectedStatus={selectedStatus} toast={toast} setList={setList} setShowEdit={setShowStatusEdit} />}/>
      }
      {showDepartmentEdit &&
        <EditPopup setShowEdit={setShowDepartmentEdit} width={'50%'} Container={<DepartmentEdit selectedOrder={selectedOrder} selectedDepartment={selectedDepartment} toast={toast} setList={setList} setShowEdit={setShowDepartmentEdit} />}/>
      }
      <ToastContainer/>
    </div>
  )
}

export default Index
